import * as React from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';
import {Breadcrumb} from '~/components/Breadcrumps';
import {useAbility} from '~/lib/ability';
import {ClientsAbility} from '~/modules/Clients/ability';
import {clientsLinks} from '~/modules/Clients/links';
import {AgenciesView} from '~/modules/Clients/views/AgenciesView';
import {AgencyView} from '~/modules/Clients/views/AgencyView';
import {SellersView} from '~/modules/Clients/views/SellersView';
import {SellerView} from '~/modules/Clients/views/SellerView';

const AgenciesRoute = () => (
    <Routes>
        <Route index element={<AgenciesView/>}/>
        <Route path=":agencyId" element={<AgencyView/>}/>
        <Route path="*" element={<Navigate to={clientsLinks.agencies()} replace />}/>
    </Routes>
);

const SellersRoute = () => (
    <Routes>
        <Route index element={<SellersView/>}/>
        <Route path=":sellerId" element={<SellerView/>}/>
        <Route path="*" element={<Navigate to={clientsLinks.sellers()} replace />}/>
    </Routes>
);

export const ClientsRoute = () => {
    const abilities = useAbility(ClientsAbility);

    return <Breadcrumb breadcrumb={{
        title: 'Clients',
        to: clientsLinks.clients()
    }}>
        <Routes>
            {abilities.canViewAgencies() && <Route path="agencies/*" element={<AgenciesRoute/>}/>}
            {abilities.canViewSellers() && <Route path="sellers/*" element={<SellersRoute/>}/>}
            <Route path="*" element={<Navigate to={clientsLinks.agencies()} replace />}/>
        </Routes>
    </Breadcrumb>;
};
